import Styles from '../ShapesTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { AI } from 'blaze-ui/icons'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Editor, track } from '@tldraw/tldraw'
import { observer } from 'mobx-react-lite'
import { Pressable } from '@react-aria/interactions'
import { BlazeShape } from 'components/VisualStudioPlayground/Shapes/Types'

interface Props {
  editor: Editor
  shape: BlazeShape
}

export const AutoUpdatableToggle = track(
  observer(({ editor, shape }: Props) => {
    const { isAutoUpdatable } = shape.props

    const toggleUpdatable = () => {
      editor.updateShape({
        ...shape,
        props: {
          isAutoUpdatable: !isAutoUpdatable,
        },
      })
    }

    return (
      <div className={Styles.colorSection}>
        <Pressable onPress={() => toggleUpdatable()}>
          <div className={Styles.actionRow}>
            <AI color="var(--selected-fill)" />
            <span className={Styles.actionName}>
              <Text variant="smallList">Allow autoupdate</Text>
            </span>
            <ToggleButton name="autoupdatable" size="sm-md" checked={isAutoUpdatable} handleChange={() => {}} />
          </div>
        </Pressable>
      </div>
    )
  }),
)
